import api from 'shared/api';

export const setLicenseUserPassword = (userId, data) => {
  const url = `/api/v1/users/${userId}/set_password/`;
  return api.post(url, data);
};
